<template>
  <div class="question-list">
    <div class="currentTime">
      <!-- {{ currentTime | moment("HH:mm") }} -->
    </div>
    <div class="list">
      <div class="header">
        <div class="header-left">
          <van-icon name="question-o" />
          <span>热门问题</span>
        </div>
        <div class="header-right" @click="doExchange">
          <van-icon name="exchange" />
          <span>换一换</span>
        </div>
      </div>
      <van-cell-group v-if="list.length > 0">
        <van-cell v-for="(item, index) in list" :key="index" :title="item.title" center is-link @click="doChoose(item)">
        </van-cell>
      </van-cell-group>
      <!-- <van-empty description="暂无热门问题" v-else /> -->
      <div v-else class="user-tips">暂无热门问题</div>
    </div>
  </div>
</template>
<script>
import { getTopQuestion } from "@/api/business";
import moment from "moment";
export default {
  name: "TopQuestion",
  data() {
    return {
      currentTime: new Date(),
      list: [],
      page: {
        current: 1,
        size: 5
      },
      totalPage: 0
    };
  },
  created() {
    this.getTopQuestion();
  },
  methods: {
    async getTopQuestion() {
      let { status, resultData } = await getTopQuestion(this.page);
      if (status === "complete") {
        if (resultData && resultData.records) {
          this.list = resultData.records;
          this.totalPage = resultData.pages;
        }
      }
    },
    doExchange() {
      if (this.page.current >= this.totalPage) {
        this.page.current = 1;
      } else {
        this.page.current++;
      }
      this.getTopQuestion();
    },
    doChoose(item) {
      this.$emit("handle-choose", item.title);
    }
  }
};
</script>

<style lang="less" scoped>
.question-list {
  .currentTime {
    text-align: center;
    color: rgba(0, 0, 0, 0.5);
    font-size: 10px;
    margin-bottom: 10px;
  }
  .list {
    /deep/ .van-hairline--top-bottom::after,
    /deep/ .van-hairline-unset--top-bottom::after {
      border-width: 0px;
    }
    background: #ffffff;
    border-radius: 20px;
    padding: 8px;
    min-height: 200px;
    .header {
      width: 100%;
      height: 48px;
      line-height: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: PingFangSC-Regular;
      border-bottom: 1px solid #ebedf0;
      &-left {
        span {
          font-size: 16px;
          font-weight: bold;
          color: 000;
          margin-left: 10px;
          vertical-align: super;
        }
        i {
          font-size: 30px;
          color: #1989fa;
        }
        margin-left: 10px;
      }
      &-right {
        margin-right: 10px;
        cursor: pointer;
        span {
          font-size: 13px;
          font-weight: 100;
          color: #767576;
          margin-left: 10px;
        }
      }
    }
  }
}
.user-tips {
  text-align: center;
  color: #999;
  padding: 30px 0;
}
</style>
